import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Badge, FormField, Popover, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiCheckCircle } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCharge, getCookie, getUrlVersion, getUser, getUserType } from '../../../../commons/functions';



export const ReportsFinancesUsersChargesPage = () => {
    const { menu, data } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();



    const [users, setUsers] = useState<any[]>([]);

    const handleGetDuplicates = async () => {

        //try {
        //setLoading(true);
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-routing': '/private/reports/finance/userscharges',
                'JWT': getCookie("JWT"),

            },
            body: JSON.stringify({})
        });
        if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
        }

        const dataWeb = await response.json();

        if (dataWeb && dataWeb.users) {
            console.log(dataWeb.users)
            const usrs = dataWeb.users.map((user: any) => {
                return {
                    userType: getUserType(user.idUserType, data).userType,
                    displayName: getUser(user.idUser, data)?.displayName ?? user.idUser,
                    ...user,
                };
            })
            setUsers(usrs);
        }
        //storeAdmin(data);
        // Create a new list with updated 'accesos' field before setting it to state
        /*
                } catch (error) {
                    console.error('Error fetching users:', error);
                } finally {
                    setLoading(false);
                }
                    */
    };
    const staticColumns = [
        {
            id: "displayName",
            header: "Usuario",
            cell: (item: any) => <FormField label={item.displayName}>{item.userType}</FormField>,
        },
        // Add other static columns (like idUser, idUserType) here if needed
    ];
    const sampleItem = users[0] || {};

    const dynamicColumns = Object.keys(sampleItem)
        .filter(chargeKey => !isNaN(Number(chargeKey)))
        .map((chargeKey, index) => ({
            id: chargeKey,
            header: <Popover triggerType="custom" position="bottom" content={getCharge(Number(chargeKey), data)?.charge || chargeKey}><Badge color='blue'>{index + 1}</Badge></Popover>,
            cell: (item: any) => (item[chargeKey] === 1 ? <Popover triggerType="custom" position="bottom" content={getCharge(Number(chargeKey), data)?.charge || chargeKey}><Icon path={mdiCheckCircle} size={1} color="green" /></Popover> : null),
        }));

    ////<Popover position="bottom" content={getCharge(Number(chargeKey), data)?.charge || chargeKey}><Badge>{index + 1}</Badge></Popover>, // Uses the key name (e.g., "77343", "2228342") as the header //chargeKey

    // 3. Combine both for your Cloudscape Table columnDefinitions
    const columnDefinitions = [...staticColumns, ...dynamicColumns];
    console.log(columnDefinitions)
    useEffect(() => {
        handleGetDuplicates();
    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Usuarios/Cargos</Header>
                    <Table
                        variant='embedded'
                        stickyHeader
                        columnDefinitions={columnDefinitions}
                        items={users}
                        loadingText="Cargando abonos duplicados..."
                    />

                </SpaceBetween>
            }
        />
    );
};
